import { Lock } from '@ankr.com/ui';
import { Typography } from '@mui/material';

import { useLockedTabStyles } from './useLockedTabStyles';

interface LockedTabProps {
  title?: React.ReactNode;
}

export const LockedTab = ({ title }: LockedTabProps) => {
  const { classes } = useLockedTabStyles();

  return (
    <div className={classes.root}>
      <Lock className={classes.lockIcon} />
      <Typography className={classes.title}>{title}</Typography>
    </div>
  );
};
